import type { TypeOrArray } from '../../../../common-interfaces';
import type { DropDownResult } from '../../../../fields/drop-down/drop-down-types';
import type { JsonDataItem } from '../../../../generic-types';
import type { VisibilityCondition } from '../../visibility-condition.interfaces';
import type { ITargetValueConverter, ValueConverterReturnType } from './i-target-value-converter';

export class TrainingTargetValueConverter implements ITargetValueConverter {
  public convert(condition: VisibilityCondition, data: JsonDataItem): TypeOrArray<ValueConverterReturnType> {
    if (condition.sourceFieldId && data?.[condition.sourceFieldId]) {
      const dataItem = data?.[condition.sourceFieldId] as DropDownResult;

      if (condition.targetValue === 'IS_FOR_ONLINE_LEARNING') {
        const isOnlineLearning = (dataItem.originalData?.['onlineLearning'] as boolean) ?? false;
        return [isOnlineLearning, true, condition.negation ?? false, condition.filterOperator ?? 'EQUALS'];
      }

      return [
        Number(dataItem.value),
        Number(condition.targetValueId),
        condition.negation ?? false,
        condition.filterOperator ?? 'EQUALS',
      ];
    }

    return [undefined, condition.targetValueId, condition.negation ?? false, condition.filterOperator ?? 'EQUALS'];
  }
}
